import { render } from "./ActionDrawer.vue?vue&type=template&id=08504a6c&ts=true"
import script from "./ActionDrawer.vue?vue&type=script&lang=ts"
export * from "./ActionDrawer.vue?vue&type=script&lang=ts"

import "./ActionDrawer.vue?vue&type=style&index=0&id=08504a6c&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__